import DashboardOpportunityLayout from './DashboardOpportunityLayout';
export default DashboardOpportunityLayout;
